import Vue from 'vue'
import axios from 'axios'
import store from '../store'

const vueObj = new Vue()

const state = {
  limit: 10,
  isFetching: false,
  isRequesting: false,
  isMore: true,
  showDetailModal: false,
  showFormModal: false,
  selectedIndex: null,
  listings: [],
  listing: null,
  center: null,
  markers: []
}

const newUserPlace = {
  user_id: null,
  place_name: null,
  place_size_id: 1,
  province_id: 1,
  address: null,
  latitude: null,
  longitude: null,
  remark: null,
  pet_remark: null,
  checklist: null,
  address_province_id: null,
  district_id: null,
  sub_district_id: null
}

const actions = {
  LOAD_LISTING_LIST: ({commit}, queryData) => {
    commit('SET_LISTING', null)
    commit('REQUEST_LISTING_LIST')
    Vue.http.get('users-places', {params: queryData})
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          (queryData.page > 0) ? commit('ADD_LISTING_LIST', response.listings) : commit('SET_LISTING_LIST', response.listings)
        } else {
          commit('SET_NO_DATA')
        }
      })
  },
  LOAD_LISTING_DETAIL: async ({commit}, id) => {
    commit('SET_LISTING_DETAIL', null)
    const url = `users-places/${id}`
    const { data } = await axios.get(url)
    if (!data.error) {
      commit('SET_LISTING_DETAIL', data)
      // Set listing map
      const lat = data.latitude
      const lng = data.longitude
      const center = {lat: lat, lng: lng}
      const markers = []
      markers[0] = {position: center}
      commit('SET_MAP_CENTER', center)
      commit('SET_MAP_MARKERS', markers)
    }
  },
  SAVE_USER_PLACE: async ({commit}, submitData) => {
    commit('SET_IS_REQUESTING', true)
    const url = 'users-places'
    let res = await axios.post(url, submitData)
    if (res) {
      const response = res.data
      if (!response.error) {
        commit('ADD_NEW_LISTING_LIST', response.user_place)
        // vueObj.$swal({text: 'Success', type: 'success'})
      } else {
        vueObj.$swal({text: response.message, type: 'error'})
      }
      commit('SET_IS_REQUESTING', false)
    }
  },
  UPDATE_USER_PLACE: async ({commit}, submitData) => {
    const url = 'users-places'
    let res = await axios.post(url, submitData)
    if (res) {
      const response = res.data
      if (!response.error) {
        console.log('success')
        store.commit('booking/UPDATE_PRE_CHECKOUT_DATA', {key: 'user_place', value: response.user_place})
      } else {
        console.log('fail to update')
      }
      commit('SET_IS_REQUESTING', false)
    }
  },
  ADD_LISTING: ({commit}, submitData) => {
    commit('SET_IS_REQUESTING', true)
    const url = 'users-places'
    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          const newListing = {
            id: response.id,
            place_name: response.data.place_name,
            place_size_id: response.data.place_size_id,
            province_id: response.data.province_id,
            address: response.data.address,
            latitude: response.data.latitude,
            longitude: response.data.longitude,
            remark: response.data.remark
          }
          commit('ADD_NEW_LISTING_LIST', newListing)
        } else {
          alert(response.message)
        }
        commit('SET_IS_REQUESTING', false)
      })
  },
  UPDATE_LISTING: ({commit}, submitData) => {
    commit('SET_IS_REQUESTING', true)
    const url = 'users-places'
    Vue.http.put(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          const updatedData = {
            index: submitData.index,
            listing: submitData
          }
          commit('UPDATE_LISTING_LIST', updatedData)
        } else {
          alert(response.message)
        }
        commit('SET_IS_REQUESTING', false)
      })
  },
  DELETE_LISTING: ({commit}, id) => {
    const submitData = {id: id}
    Vue.http.delete('users-places', {body: submitData})
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          commit('DELETE_LISTING_LIST')
        } else {
          alert(response.message)
        }
      })
  }
}

const mutations = {
  SET_LISTING: (state) => {
    state.listing = null
  },
  CREATE_NEW_USER_PLACE: (state) => {
    state.listing = {...newUserPlace}
  },
  REQUEST_LISTING_LIST: (state) => {
    state.isFetching = true
  },
  SET_NO_DATA: (state) => {
    state.isMore = false
  },
  SET_SELECTED_INDEX: (state, index) => {
    state.selectedIndex = index
  },
  SET_LISTING_LIST: (state, listings) => {
    state.listings = listings
    state.isFetching = false
    state.isMore = true
    if (listings.length < state.limit) {
      state.isMore = false
    }
  },
  ADD_LISTING_LIST: (state, listings) => {
    state.isFetching = false
    state.isMore = true
    for (let key in listings) {
      state.listings.push(listings[key])
    }
  },
  ADD_NEW_LISTING_LIST: (state, listing) => {
    state.listings.unshift(listing)
  },
  UPDATE_LISTING_LIST: (state, updatedData) => {
    if (state.selectedIndex) {
      state.listings.splice(state.selectedIndex, 1, updatedData.listing)
    }
  },
  DELETE_LISTING_LIST: (state) => {
    if (state.selectedIndex) {
      state.listings.splice(state.selectedIndex, 1)
    }
  },
  SET_IS_REQUESTING: (state, status) => {
    state.isRequesting = status
  },
  SET_LISTING_DETAIL: (state, listing) => {
    state.isRequesting = false
    state.listing = listing
  },
  SET_MODAL_DISPLAY: (state, params) => {
    state.isRequesting = false
    if (params.type === 'detail') {
      state.showDetailModal = params.status
    } else {
      state.showFormModal = params.status
    }
  },
  SET_MAP_CENTER: (state, center) => {
    state.center = center
  },
  SET_MAP_MARKERS: (state, markers) => {
    state.markers = markers
  },
  UPDATE_FORM_DATA: (state, data) => {
    state.listing[data.key] = data.value
  },
  SET_EMPTY_FORM: (state) => {
    state.listing = {
      place_name: null,
      place_size_id: 1,
      province_id: 1,
      address: null,
      latitude: 0,
      longitude: 0,
      remark: null
    }
  }
}

const getters = {
  getState: state => {
    return state
  },
  isLoadMore: state => {
    return state.isFetching ? 'message.button.loading' : 'message.button.load_more'
  },
  getListings: state => {
    return state.listings
  },
  getListingDetail: state => {
    return state.listing
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/listing.js